var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iPhoneX",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s0631---Comments-/-Add-Comment-Loading",
    transform: "translate(-340.000000, -592.000000)",
    fill: "#969FA2",
    fillRule: "nonzero",
    stroke: "#969FA2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sync",
    transform: "translate(341.000000, 593.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.225,6 L1.463,6 C3.325,3.535 5.263,1 9.538,1 C14.2451879,1.02202215 18.0500465,5.04501641 18.05,10 L19,10 C19,4.48884705 14.7640717,0.0165334588 9.5285,0 C5.00175,0 2.812,2.625 0.95,5.075 L0.95,1.5 L0,1.5 L0,7 L5.225,7 L5.225,6 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.775,13.6 L17.1,13.6 C17.1,13.6 17.518,13.6 17.51325,13.6 C15.61325,15.805 13.68475,18.1 9.43825,18.1 C4.74034805,18.0678556 0.949877473,14.45076 0.95,10 L0,10 C0,14.9495506 4.21856843,18.9703027 9.443,19 C13.97925,19 16.15,16.6105 18.05,14.4145 L18.05,17.65 L19,17.65 L19,12.7 L13.775,12.7 L13.775,13.6 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingIndicator);
export default __webpack_public_path__ + "static/media/loading-indicator.f2cb46b8ae1ce5c722079a540bd8c6fa.svg";
export { ForwardRef as ReactComponent };